import React, { Component } from 'react';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';

import HistoryModal from "../../api/History";
import moment from "moment";
import { Loading } from "../../components";
import Table from './Table';

import * as select from '../../reducers';
import * as actionsHistory from '../../actions/history';

import "../../styles/components/_history.scss";
import "../../styles/components/_table.scss";

class History extends Component {
  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    const { today, twoYearsAgo } = this.fetchDateRange();
    this.props.fetchHistory(twoYearsAgo, today);
  }

  fetchDateRange() {
    const endCurrentFinancialYear = moment();
    endCurrentFinancialYear.month(5);
    endCurrentFinancialYear.date(30);

    if (endCurrentFinancialYear.isBefore(moment())) {
      endCurrentFinancialYear.add(1, 'year');
    }

    const startCurrentFinancialYear = moment(endCurrentFinancialYear.format('YYYY-MM-DD'));
    startCurrentFinancialYear.subtract(1, 'year').month(6).date(1);

    const startLastFinancialYear = moment(startCurrentFinancialYear.format('YYYY-MM-DD'));
    startLastFinancialYear.subtract(1, 'year');

    const endLastFinancialYear = moment(endCurrentFinancialYear.format('YYYY-MM-DD'));
    endLastFinancialYear.subtract(1, 'year');

    const today = moment();
    const twoYearsAgo = moment().subtract(2, 'years');

    return {
      endCurrentFinancialYear,
      startCurrentFinancialYear,
      startLastFinancialYear,
      endLastFinancialYear,
      today,
      twoYearsAgo,
    };
  }

  render() {
    const { history, historyLoading, historyError, historyLinks } = this.props;
    const { endCurrentFinancialYear, startCurrentFinancialYear, startLastFinancialYear, endLastFinancialYear, today, twoYearsAgo } = this.fetchDateRange();

    return (
      <section>
        <MetaTags>
          <title>AFES - Support History</title>
        </MetaTags>

        <div className="program__wrap history__wrap">
          <div>
            <h2>My Support History</h2>
            <p>Print my support summary for:</p>
            <div className="btn__wrapper">
              <button
                onClick={() => {
                  HistoryModal.getAnnualReport(startCurrentFinancialYear.format('YYYY-MM-DD'), endCurrentFinancialYear.format('YYYY-MM-DD'));
                }}
                className="btn_blue btn_blue--invoice btn_blue--skinny"
              >
                Current financial year
              </button>
              <span className="btn__content">{startCurrentFinancialYear.format('D/M/YYYY')} to date</span>
            </div>
            <div className="btn__wrapper">
              <button
                onClick={() => {
                  HistoryModal.getAnnualReport(startLastFinancialYear.format('YYYY-MM-DD'), endLastFinancialYear.format('YYYY-MM-DD'));
                }}
                className="btn_blue btn_blue--invoice btn_blue--skinny"
              >
                Prior financial year
              </button>
              <span className="btn__content">
                {startLastFinancialYear.format('YYYY')}/{startCurrentFinancialYear.format('YYYY')}
              </span>
            </div>
          </div>
          {historyLoading ? (
            <div className="support-history__loading">
              <Loading variant="inline" />
            </div>
          ) : historyError ? (
            <div className="support-history">
              <p className="form__alert error">{historyError}</p>
            </div>
          ) : (
            <Table history={history} startDate={twoYearsAgo} endDate={today} meta={historyLinks} fetchHistory={this.props.fetchHistory} />
          )}
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    history: select.getHistory(state),
    historyError: select.getHistoryError(state),
    historyLoading: select.getHistoryLoading(state),
    historyLinks: state.history.historyLinks
  };
};

export default connect(mapStateToProps, {
  ...actionsHistory,
})(History);
